<template>
  <section class="container">
    <!-- 首页应用 -->
    <section class="all_mess">
      <h3>首页应用</h3>
      <ul>
        <li class="icon" v-for="(item,index) in indexIconList" :key="item.desc">
          <img
            class="icon_img_content"
            :src="require(`../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
          />
          <p class="icon_desc">{{item.text}}</p>
          <img
            class="btn_delete"
            @click="delectIcon(index)"
            src="../../assets/images/btn_delete.png"
          />
        </li>
      </ul>
    </section>
    <!-- 全部应用 -->
    <section class="all_mess all_module">
      <h3>全部应用</h3>
      <ul>
        <li class="icon" v-for="item in lastList" :key="item.desc">
          <img
            class="icon_img_content"
            :src="require(`../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
          />
          <p class="icon_desc">{{item.text}}</p>
          <img
            class="btn_delete"
            @click="addIcon(item)"
            :src="require(`../../assets/images/btn_add_${common.theme}.png`)"
          />
        </li>
      </ul>
    </section>
    <section v-if="$store.state.common.theme==3" class="footer_box button">
      <span class="btn_left_theme4 btn_primary" @click="cancelFun">取消</span>
      <span class="btn_right_theme4 btn_bm" @click="sureFun">确定</span>
    </section>
    <section v-else class="footer_box button">
      <span class="btn_left btn_primary" @click="cancelFun">取消</span>
      <span class="btn_right btn_bm" @click="sureFun">确定</span>
    </section>
  </section>
</template>
<script>
import util from "../../utils/util";
import { mapState, mapActions } from "vuex";
import { setWapServerButtonByUser } from '../../utils/api';
export default {
  name: "allModule",
  data() {
    return {
      indexList: [],
      lastList: [],
      // iconStyle:this.home.iconStyle
    };
  },
  computed: {
    ...mapState({
      common: state => state.common,
      home: state => state.home
    }),
    indexIconList() {
      let newA = this.home.indexNavList.filter(item => item.text != "全部");
      return newA;
    },
    iconStyle() {
      return this.home.iconStyle
    }
  },
  created() {
    this.lastListFun(this.home.indexNavList)
  },
  methods: {
    ...mapActions(['getIndexStyle']),
    delectIcon(index) {
      if (this.indexIconList.length === 1) {
        util.showToast("首页应用最少保留1个")
        return false;
      }
      this.indexIconList.splice(index, 1)
      this.lastListFun(this.indexIconList)
    },
    addIcon(item) {
      if (this.indexIconList.length === 9) {
        util.showToast("首页应用最多添加9个")
        return false;
      }
      this.indexIconList.push(item)
      this.lastListFun(this.indexIconList)
    },
    lastListFun(a) {
      let b = this.home.navList;
      let arr = [...b].filter(x => [...a].every(y => y.text !== x.text));
      arr = arr.filter(item => item.text != "全部");
      this.lastList = arr;
    },
    cancelFun() {
      this.$router.go(-1)
    },
    sureFun() {
      util.showLoading();
      let params = {
        marketId: this.common.marketInfo.id,
        indexList: this.indexIconList
      }
      setWapServerButtonByUser(params).then(res => {
        console.log(res)
        util.hideLoading()
        if (res.res.code === 10000) {
          this.getIndexStyle(res.body)
          this.$router.go(-2)
          util.showToast('操作成功')
        } else {
          util.showToast(res.res.msg)
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  min-height: 100vh;
}
// 全部应用
.all_mess {
  border-bottom: 14px solid #eee;
  h3 {
    height: 44px;
    font-size: 32px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 44px;
    padding: 28px 0 20px 28px;
  }
  ul {
    .flex();
    li {
      width: 25%;
      .flex();
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      .border();
      border-left: 0;
      box-sizing: border-box;
      &:nth-child(4n) {
        border-right: 0;
      }
      &:nth-child(5n) {
        border-top: 0;
      }
      &:nth-child(6n) {
        border-top: 0;
      }
      &:nth-child(7n) {
        border-top: 0;
      }
      &:nth-child(8n) {
        border-top: 0;
      }
      &:nth-child(9n) {
        border-top: 0;
      }
      .icon_img_content {
        display: block;
        width: 100px;
        height: 100px;
        padding: 24px 0 6px;
      }
      .icon_desc {
        height: 34px;
        font-size: 24px;
        color: rgba(51, 51, 51, 1);
        line-height: 34px;
        margin-bottom: 24px;
      }
      .btn_delete {
        position: absolute;
        top: 0;
        right: 0;
        padding: 10px;
        width: 28px;
        height: 28px;
      }
    }
  }
}
.all_module {
  margin-bottom: 140px;
  border: 0;
}
.footer_box {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 120px;
  .flex();
  justify-content: center;
  background: #fff;
  align-items: center;
  span {
    display: block;
    width: 332px;
    height: 68px;
    line-height: 68px;
    text-align: center;
    margin: 0 10px;
    border-radius: 4px;
    font-size: 28px;
    &.btn_left {
      background: rgba(243, 245, 253, 1);
      .border(@color17);
      color: @color17;
      box-sizing: border-box;
    }
    &.btn_left_theme4 {
      background: rgba(243, 245, 253, 1);
      border: 1px solid #a1805d;
      color: #a1805d;
      box-sizing: border-box;
    }
    &.btn_right {
      color: #fff;
      background: @color17;
    }
    &.btn_right_theme4 {
      color: #fff;
      background: #a1805d;
    }
  }
}
</style>
